export default {
    background: "https://assets.swoogo.com/uploads/full/4575580-671a91fb62c3d.png",
    links: [
        {
            label: "ThreatLocker",
            href: "/exhibition-hall-platinum",
            width: "24%",
            height: "38.7%",
            left: "38.2%",
            top: "4.4%",
        },
        {
            label: "Security Scorecard",
            href: "/exhibition-hall-gold",
            width: "19%",
            height: "31.7%",
            left: "63.2%",
            top: "16.4%",
        },
        {
            label: "Securecloud",
            href: "/exhibition-hall-gold",
            width: "19%",
            height: "31.7%",
            left: "18.5%",
            top: "16.4%",
        },
        {
            label: "BlackDuck",
            href: "/exhibition-hall-silver-bronze",
            width: "12.3%",
            height: "19.7%",
            left: "4.5%",
            top: "27.4%",
        },
        {
            label: "DataBee",
            href: "/exhibition-hall-silver-bronze",
            width: "12.3%",
            height: "19.7%",
            left: "83.9%",
            top: "27.4%",
        },
        {
            label: "Illumio",
            href: "/exhibition-hall-silver-bronze",
            width: "12.3%",
            height: "17.7%",
            left: "44%",
            top: "45.4%",
        },
        {
            label: "Back to Atrium",
            href: "/atrium",
            width: "14.3%",
            height: "7.7%",
            left: "43%",
            top: "91.4%",
        },
    ],
    name: "exhibition-hall",
}